<script>
    import {onMount} from 'svelte';

    let container;

    onMount(()=>{
      container.childNodes.forEach(element => {
             let currentClass = element.className;
            element.className= currentClass + ' md:flex-1 px-4 md:mb-0 mt-16';
        });
    })
</script>


<div class="md:flex md:flex-row" bind:this={container}>
    <slot></slot>
</div>